import { QUICK_ORDER_QUERY, QUICK_ORDER_RECEIVE, QUICK_ORDER_IS_LOADING, QUICK_ORDER_IS_AUTO_COMPLETE_LOADING } from '../constants';

const DEFAULT_STATE = {
    query: null,
    currentRow: null,
    isLoading: false,
    queryResult: null,
    isShowingSpecificVariant: false,
    error: null
};

export const quickOrder = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case QUICK_ORDER_QUERY:
        case QUICK_ORDER_RECEIVE:
        case QUICK_ORDER_IS_LOADING:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}